import { types } from '../actions/types';

export const SalesReducer = (
  state = {
    byProvider: null,
    bySeller: null,
  },
  action,
) => {
  switch (action.type) {
    case types.smGetSalesByProvider:
      return {
        ...state,
        byProvider: {
          status: action.payload?.status,
          message: action.payload?.message,
          data: action.payload?.data,
        },
      };
    case types.smGetSalesBySeller:
      return {
        ...state,
        bySeller: {
          status: action.payload?.status,
          message: action.payload?.message,
          data: action.payload?.data,
        },
      };
    default:
      return state;
  }
};
